/**
 * Cycle 452.1: the on-screen labels a person follows on their phone to
 * approve a kiosk, and the pairing instructions built from them.
 *
 * Each constant is the label the SPA actually renders at that step, and
 * each rendering site reads it from here (the Settings tab, the Account
 * index row and section title, the Devices card, the Manage devices row,
 * the Pair a device button), so renaming a label renames the instructions
 * with it. `web/src/lib/__tests__/pairDevicePath.test.ts` pins both halves.
 */
export const SETTINGS_TAB_LABEL = "Settings";
export const ACCOUNT_SECTION_LABEL = "Account";
export const DEVICES_CARD_LABEL = "Devices";
export const MANAGE_DEVICES_LABEL = "Manage devices";
export const PAIR_A_DEVICE_LABEL = "Pair a device";

/** "Settings → Account → Devices → Manage devices → Pair a device" */
export const PAIR_DEVICE_PATH = [
  SETTINGS_TAB_LABEL,
  ACCOUNT_SECTION_LABEL,
  DEVICES_CARD_LABEL,
  MANAGE_DEVICES_LABEL,
  PAIR_A_DEVICE_LABEL,
].join(" → ");
